import { useLayoutEffect } from "react";
import { useLocation } from "react-router-dom";

export function useHashScroll(root?: React.RefObject<HTMLElement>) {
  const { hash } = useLocation();

  useLayoutEffect(() => {
    if (!hash) return;
    const sel = hash; // "#my-id"
    const scope: Document | HTMLElement = root?.current ?? document;
    const target = scope.querySelector?.(sel) as HTMLElement | null;
    if (target) {
      requestAnimationFrame(() => {
        target.scrollIntoView({
          behavior: "smooth",
          block: "start",
          inline: "nearest",
        });
      });
    }
  }, [hash, root]);
}
